import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@sentinel/ui';

export interface WebAuthnStepProps {
  onRegister: () => void;
  status: 'idle' | 'pending' | 'success' | 'error';
  error?: string | null;
  supported: boolean;
}

export function WebAuthnStep({ onRegister, status, error, supported }: WebAuthnStepProps) {
  const { t } = useTranslation('mfa');

  if (!supported) {
    return (
      <Alert type="warning" role="alert">
        {t('webauthn_unsupported')}
      </Alert>
    );
  }

  return (
    <div style={{ display: 'grid', gap: '1rem' }}>
      <p>{t('webauthn_intro')}</p>

      {error ? (
        <Alert type="error" role="alert">
          {error}
        </Alert>
      ) : null}

      {status === 'success' ? (
        <Alert type="success" role="status" data-testid="webauthn-success">
          {t('webauthn_success')}
        </Alert>
      ) : null}

      <Button
        type="button"
        data-testid="mfa-webauthn-register"
        onClick={onRegister}
        disabled={status === 'pending'}
      >
        {status === 'pending' ? t('webauthn_registering') : t('webauthn_register')}
      </Button>
    </div>
  );
}
